<template>
  <v-app class="d-flex flex-column">
    <!-- <v-content class="d-inline-flex" fluid style="border: 2px solid red; overflow: scroll">
      <v-container>
        <v-row>
          <v-col cols="6">
            <v-row class="grey lighten-5">
              <v-card v-for="n in 43" :key="n" class="ma-3 pa-6" outlined tile>Column</v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>-->

    <v-navigation-drawer clipped app floating permanent v-if="isLoggedIn && onDesktop">
      <v-card class="ma-2 mt-12" :to="{ name: 'dashboard'}" :color="cardColour('dashboard')">
        <v-card-text class="ml-n2">
          <v-avatar :color="circleColour('dashboard')" size="65">
            <span>
              <v-img width="40px" :src="require('@/assets/main/imgDashboard.png')"></v-img>
            </span>
          </v-avatar>
          <span class="purple--text text-h6 font-weight-bold ml-3">Dashboards</span>
        </v-card-text>
      </v-card>

      <v-card class="ma-2" :to="{ name: 'projects'}" :color="cardColour('projects')">
        <v-card-text class="ml-n2">
          <v-avatar :color="circleColour('projects')" size="65">
            <span class="white--text headline">
              <v-img width="40px" :src="require('@/assets/main/imgProjects.png')"></v-img>
            </span>
          </v-avatar>
          <span class="purple--text text-h6 font-weight-bold ml-3">Projects</span>
        </v-card-text>
      </v-card>

      <v-card class="ma-2" :to="{ name: 'clients'}" :color="cardColour('clients')">
        <v-card-text class="ml-n2">
          <v-avatar :color="circleColour('clients')" size="65">
            <span class="white--text headline">
              <v-img width="40px" :src="require('@/assets/main/imgClient.png')"></v-img>
            </span>
          </v-avatar>
          <span class="purple--text text-h6 font-weight-bold ml-3">Clients</span>
        </v-card-text>
      </v-card>

      <v-card class="ma-2" :to="{ name: 'settings'}" :color="cardColour('settings')">
        <v-card-text class="ml-n2">
          <v-avatar :color="circleColour('settings')" size="65">
            <span class="white--text headline">
              <v-img width="40px" :src="require('@/assets/main/imgSettings.png')"></v-img>
            </span>
          </v-avatar>
          <span class="purple--text text-h6 font-weight-bold ml-3">Settings</span>
        </v-card-text>
      </v-card>

      <!-- <v-card class="ma-2" :to="{ name: 'clients'}">
        <v-img class="white--text align-end" :src="require('@/assets/main/imgClient.png')"></v-img>
        <v-card-title class="purple--text font-weight-bold mt-n4">Clients</v-card-title>
      </v-card>

      <v-card class="ma-2" :to="{ name: 'settings'}">
        <v-img class="white--text align-end" :src="require('@/assets/main/imgSettings.png')"></v-img>
        <v-card-title class="purple--text font-weight-bold mt-n4">Settings</v-card-title>
      </v-card>-->
    </v-navigation-drawer>

    <TopAppBar v-if="isLoggedIn"></TopAppBar>

    <!-- on mobile -->
    <v-content v-if="onMobile">
      <transition name="slide7" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-content>

    <!-- on desktop -->
    <v-content v-if="onDesktop">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </v-content>

    <BottomNav app v-if="onMobile && isLoggedIn"></BottomNav>

    <v-footer app v-if="onDesktop && isLoggedIn" color="blue-grey" class="white--text">
      <span>Loggable</span>
      <span class="caption ml-3">&copy; 2020</span>
      <v-spacer />
    </v-footer>
  </v-app>
</template>

<script>
import firebase from "firebase/app";
import TopAppBar from "./components/navigation/TopAppBar";
import BottomNav from "./components/navigation/BottomNav";

export default {
  props: {
    source: String,
  },
  components: { TopAppBar, BottomNav },
  data: () => ({
    prevHeight: 0,
    //transitionName: "fade"
  }),
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    path() {
      return this.$route.path;
    },
    onMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    onDesktop() {
      return !this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    cardColour(mode) {
      let pathName = this.$route.name;
      if (pathName == mode) return "rgb(223, 213, 253)";
      return "white";
    },
    circleColour(mode) {
      let pathName = this.$route.name;
      if (pathName == mode) return "white"; // #5044ff
      return "#9e9e9e1f";
    },
    // getBackgroundColour(mode) {
    //   let cid = this.client.cid;
    //   let projects = this.$store.getters.getRelatedProjects(cid);
    //   if (projects.length > 0) this.selectedProject = projects[0];
    //   return projects;
    // },
    // beforeLeave(element) {
    //   this.prevHeight = getComputedStyle(element).height;
    // },
    // enter(element) {
    //   const { height } = getComputedStyle(element);
    //   element.style.height = this.prevHeight;
    //   setTimeout(() => {
    //     element.style.height = height;
    //   });
    // },
    // afterEnter(element) {
    //   element.style.height = "auto";
    // }
  },
  mounted() {
    // this sets the 'dark' mode to true/false - it works with the 'theme-ing'
    // this.$vuetify.theme.dark = true;
    //this.$router.
  },
  watch: {
    $route(to, from) {
      // react to route changes - if we are moving away from 'projects' then ensure we
      // clear out the selectedProject
      //console.log("to: " + to.path, "from: " + from.path);
      if (from.path == "/projects") {
        this.$store.dispatch("setSelectedProject", null);
      }
    },
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;

      if (transitionName === "slide") {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
      }

      this.transitionName = transitionName || DEFAULT_TRANSITION;

      next();
    });
  },
};
</script>

<style lang="scss">
fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: height, opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.slide7-enter-active {
  transition: all 0.2s ease-out;
}
.slide7-leave-active {
  transition: all 0.2s ease-in;
}
.slide7-enter {
  // transform: translateX(50%);
  opacity: 0;
}
.slide7-enter-to {
  // transform: translateX(0%);
  opacity: 1;
}
.slide7-leave {
  // transform: translateX(0%);
  opacity: 1;
}
.slide7-leave-to {
  // transform: translateX(50%);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.child-view {
  position: absolute;
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}
// .slide-left-enter,
// .slide-right-leave-active {
//   opacity: 0;
//   -webkit-transform: translate(30px, 0);
//   transform: translate(30px, 0);
// }
// .slide-left-leave-active,
// .slide-right-enter {
//   opacity: 0;
//   -webkit-transform: translate(-30px, 0);
//   transform: translate(-30px, 0);
// }

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.v-toolbar__extension {
  // height: 29px !important;
  padding: 0 !important;
}

.desktop-section-row {
  cursor: pointer;
}
</style>
